const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lillaflora.nu/api';

export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  short_description: string;
  content: string;
  hero_image?: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  status: 'draft' | 'published';
  published_at?: string | null;
  created_at?: string;
  updated_at?: string;
}

const getToken = () => localStorage.getItem('lillaflora_admin_token');

export const blogService = {
  async getAll(status?: string): Promise<BlogPost[]> {
    const params = status ? `?status=${status}` : '';
    const token = getToken();
    const options: RequestInit = {};
    if (token) {
      options.headers = {
        Authorization: `Bearer ${token}`
      };
    }
    const res = await fetch(`${API_BASE_URL}/blog-posts${params}`, options);
    if (!res.ok) throw new Error('Kunde inte hämta blogginlägg');
    return res.json();
  },

  async getPublished(limit?: number): Promise<BlogPost[]> {
    const params = new URLSearchParams();
    params.append('status', 'published');
    if (limit) params.append('limit', String(limit));
    const res = await fetch(`${API_BASE_URL}/blog-posts?${params.toString()}`);
    if (!res.ok) throw new Error('Kunde inte hämta blogginlägg');
    return res.json();
  },

  async getBySlug(slug: string): Promise<BlogPost | null> {
    const token = getToken();
    const options: RequestInit = {};
    if (token) {
      options.headers = {
        Authorization: `Bearer ${token}`
      };
    }
    const res = await fetch(`${API_BASE_URL}/blog-posts/${slug}`, options);
    if (res.status === 404) return null;
    if (!res.ok) throw new Error('Kunde inte hämta bloggpost');
    return res.json();
  },

  async create(data: Partial<BlogPost>): Promise<void> {
    const token = getToken();
    const res = await fetch(`${API_BASE_URL}/blog-posts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      throw new Error(await res.text());
    }
  },

  async update(id: number, data: Partial<BlogPost>): Promise<void> {
    const token = getToken();
    const res = await fetch(`${API_BASE_URL}/blog-posts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      throw new Error(await res.text());
    }
  },

  async delete(id: number): Promise<void> {
    const token = getToken();
    const res = await fetch(`${API_BASE_URL}/blog-posts/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      throw new Error(await res.text());
    }
  }
};

export default blogService;
